import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../components/common/FormikControl";

  const Filter = ({onApply, onClear, initialFilters, versions }) => {
  const initialValues = initialFilters || {
      status: [],
      versions: [],
    }
 
const statusOption = [
  { value: 0, label: 'Pending' },
  { value: 1, label: 'Submitted' },
  { value: 2, label: 'Published' },
  { value: 3, label: 'Draft' },
]

  const formOptions = [
    {
      label: 'Status',
      type: 'checkbox',
      name: 'status',
      options: statusOption
    },
   {
      label: 'Versions',
      type: 'checkbox',
      name: 'versions',
      options: versions
    },
  ]


  
 const handleSubmit = (values) => {
  onApply(values);
};

 const handleClear = () => {
    formik.resetForm();
    onClear({ status: [], versions: [] });
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit
  })

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        {formOptions.map((props, key)=>(
          <Grid key={key} item xs={12}>
          <FormikControl formik={formik} {...props} />
          </Grid>
        ))}
        
      <Box sx={{ display: "flex", gap: 2, marginTop: "10px" }}>
          <LoadingButton fullWidth type="submit" variant="contained">
            Apply Filter
          </LoadingButton>
          <LoadingButton fullWidth variant="outlined" onClick={handleClear}>
            Clear All
          </LoadingButton>
        </Box>
      </form>
    </Box>
  );
}

export default Filter;